import React from 'react';

const Content = ({ children }) => {
    return (
      <div id="content-wrapper">
        <div className="bg-data">
          <div className="container-fluid">{children}</div>
        </div>
      </div>
    );
}

export default Content;